import LuggageOutlinedIcon from '@mui/icons-material/LuggageOutlined';
import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import CancelScheduleSendOutlinedIcon from '@mui/icons-material/CancelScheduleSendOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { ReservationDetailPage } from '../../components/ReservationDetailPage';
import { ReservationReportList } from '../../components/ReservationReportList';
import { AIR_CAPS } from '../../components/reservation/capabilities';
import AirFlowPage from './pages/AirFlowPage';
import AirReservationsPage from './pages/AirReservationsPage';
import AirTicketsPage from './pages/AirTicketsPage';
import AirEntryFindPage from './pages/AirEntryFindPage';

/** No standalone "Ek Hizmetler" (additional services) page/menu item — that was a raw
 *  admin tool, not a real feature. Seat selection (the actual need) is a step inside the
 *  booking flow itself, gated to THYNDC bookings only — see flowConfig.ts +
 *  components/AirSeatSelectionStep.tsx, which drives `Air/GetAdditionalServiceOffer` +
 *  `Air/SelectAdditionalService`/`Air/RemoveAdditionalService` directly.
 *
 *  "Rezervasyon Listesi" and "Bilet Listesi" are both backed by the shared
 *  `AirReservationList` component (see components/AirReservationList.tsx), fixed to
 *  `status: 'Prebooked'` and `status: 'Booked'` respectively — neither page exposes a
 *  status picker to the user anymore.
 *
 *  Clicking a PNR/ticket number in any of the 3 list pages above navigates to
 *  `air/reservations/:identifier` — the shared `ReservationDetailPage` (see
 *  ../../components/ReservationDetailPage.tsx), which re-fetches that one record via
 *  `Entry/Find` and, depending on its status, shows either the reservation actions
 *  (İptal Et → `Air/CancelReservation`, Opsiyon/Fiyat, Ödemeye Git) or the ticket
 *  actions (Void, İade) — plus the document menu either way. */
export const airModule: ModuleDefinition = {
  routes: [
    { path: 'air', element: <AirFlowPage /> },
    { path: 'air/reservations', element: <AirReservationsPage /> },
    {
      path: 'air/reservations/:identifier',
      element: <ReservationDetailPage capabilities={AIR_CAPS} />,
    },
    { path: 'air/tickets', element: <AirTicketsPage /> },
    {
      path: 'air/reservations/cancelled',
      element: (
        <ReservationReportList
          providerType="Air"
          status="Cancelled"
          title="İptal Rezervasyonlar Listesi"
          detailBasePath="/air/reservations"
        />
      ),
    },
    { path: 'air/entry-find', element: <AirEntryFindPage /> },
  ],
  menuItems: [
    {
      label: 'Arama',
      path: 'air',
      icon: <FlightOutlinedIcon />,
      group: 'Uçak',
      groupIcon: <LuggageOutlinedIcon />,
    },
    {
      label: 'Rezervasyon Listesi',
      path: 'air/reservations',
      icon: <ListAltOutlinedIcon />,
      group: 'Uçak',
    },
    {
      label: 'Bilet Listesi',
      path: 'air/tickets',
      icon: <ConfirmationNumberOutlinedIcon />,
      group: 'Uçak',
    },
    {
      label: 'İptal Rezervasyonlar Listesi',
      path: 'air/reservations/cancelled',
      icon: <CancelScheduleSendOutlinedIcon />,
      group: 'Uçak',
    },
    {
      label: 'Kayıt Arama',
      path: 'air/entry-find',
      icon: <ManageSearchOutlinedIcon />,
      group: 'Uçak',
    },
  ],
};
